import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import CPPSvgColor from '../assets/cpp.svg';

export const CPPColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-cpp" className={cx('sdkIcon', className)} size={size} {...props}>
    <CPPSvgColor />
  </LegacyIcon>
);
